import type { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { ArchiveIcon } from '@trello/nachos/icons/archive';
import { CopyIcon } from '@trello/nachos/icons/copy';
import { MoveIcon } from '@trello/nachos/icons/move';
import type { PopoverProps } from '@trello/nachos/popover';
import { Popover } from '@trello/nachos/popover';
import { PopoverMenu, PopoverMenuButton } from '@trello/nachos/popover-menu';

export interface InboxBulkActionsContextMenuProps {
  popoverProps: PopoverProps;
  onMove: () => void;
  onCopy: () => void;
  onArchive: () => void;
}
export const InboxBulkActionsContextMenu: FunctionComponent<
  InboxBulkActionsContextMenuProps
> = ({ popoverProps, onMove, onCopy, onArchive }) => {
  return (
    <Popover {...popoverProps}>
      <PopoverMenu>
        <PopoverMenuButton
          iconBefore={<MoveIcon />}
          onClick={onMove}
          data-testid={'inbox-bulk-actions-move'}
        >
          <FormattedMessage
            id="templates.quick_card_editor.move"
            defaultMessage="Move"
            description="Bulk inbox move card"
          />
        </PopoverMenuButton>

        <PopoverMenuButton
          iconBefore={<CopyIcon />}
          onClick={onCopy}
          data-testid={'inbox-bulk-actions-copy'}
        >
          <FormattedMessage
            id="templates.quick_card_editor.copy"
            defaultMessage="Copy"
            description="Bulk inbox copy card"
          />
        </PopoverMenuButton>

        <PopoverMenuButton
          iconBefore={<ArchiveIcon />}
          onClick={onArchive}
          data-testid={'inbox-bulk-actions-archive'}
        >
          <FormattedMessage
            id="templates.quick_card_editor.archive"
            defaultMessage="Archive"
            description="Bulk inbox archive card"
          />
        </PopoverMenuButton>
      </PopoverMenu>
    </Popover>
  );
};
